import React from 'react';
import { LoginPage } from '../../auth';

const AgentLoginPage = () => (
  <LoginPage
    title="Agent Portal"
    subtitle="Sign in to manage assigned chats."
    expectedRole="agent"
    expectedRoleLabel="Agent"
    redirectTo="/agent"
  />
);

export default AgentLoginPage;
